export default __webpack_public_path__ + "static/DrBonacci-42a7acf27d03591e5a6718f3eec75b66.jpg";